import { render } from "./NoBank.vue?vue&type=template&id=9484b896"
import script from "./NoBank.vue?vue&type=script&lang=js"
export * from "./NoBank.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__